import axios from 'axios';

export default {
	state: () => ({
		// Hcps
		apiHcpsUrl: '/api/hcp-portal/search-hcp',
		originHcps: [],
		hcps: [],
		sortedHcps: [],
		paginatedHcps: [],
		isEmpty: false,
		pagination: {
			currentPage: 1,
			itemsPerPage: 10,
			totalResults: 40,
			numberOfPages: 4
		},
		hcpsPerPage: 0,
		isPaginationEnabled: true,

		// Patients
		isSearchResultEmpty: false,
		apiPatientsUrl: '/api/hcp-portal/search-patients?sortBy=Added',
		patients: [],
		patientsSortOption: '',
		patientsSearchTerm: '',
		currentPatientPage: 1,
		patientsPagination: {
			currentPage: 1,
			itemsPerPage: 10,
			totalResultsCount:0,
			numberOfPages: 4
		},

		portalFacetGroups: [],
		defaultPortalFacetGroups: [],
		selectedFacetGroups: [],
		preparedSelectedFacetGroups: [],
		isFetchBusy: false,

		// Patient Orders History
		apiPatientOrdersUrl: '/api/hcp-portal/order-history?sortBy=Added',
		patientId: null,
		patientOrders: []
	}),
	getters: {
		getIsEmpty: (state) => {
			return state.isEmpty;
		},
		getHcps: (state) => {
			return state.hcps;
		},
		getSortedHcps: (state) => {
			return state.sortedHcps;
		},
		getHcpsPagination: (state) => {
			return state.pagination;
		},
		getIsPaginationEnabled: (state) => {
			return state.isPaginationEnabled;
		},
		// patients
		getPatients: (state) => {
			return state.patients;
		},

		// facetGroups
		getPatientsSearchTerm: (state) => {
			return state.patientsSearchTerm;
		},
		getPortalFacetGroups: (state) => {
			return state.portalFacetGroups;
		},
		getIsSearchResultEmpty: (state) => {
			return state.isSearchResultEmpty
		},
		getDefaultPortalFacetGroups: (state) => {
			return state.defaultPortalFacetGroups
		},
		getPortalSelectedFacetGroups: (state) => {
			return state.selectedFacetGroups
		},
		getPatientsPagination: (state) => {
			return state.patientsPagination
		},
		getIsFetchBusy: (state) => {
			return state.isFetchBusy
		},
		getCurrentPatientPage: (state) => {
			return state.currentPatientPage
		},

		// patientOrders
		getPatientOrders: (state) => {
			return state.patientOrders;
		},
	},
	mutations: {
		setIsEmpty: (state, status) => {
			state.isEmpty = status;
		},
		setHcps: (state, hcps) => {
			state.hcps = hcps
		},
		setOriginHcps: (state, hcps) => {
			state.originHcps = hcps
		},
		setSortedHcps: (state, sortedHcps) => {
			state.sortedHcps = sortedHcps
		},
		setHcpsPaginationCurrentPage: (state, page) => {
			state.pagination.currentPage = page;
		},
		setHcpsPagination: (state, total) => {
			state.pagination = {
				currentPage: 1,
				itemsPerPage: state.hcpsPerPage,
				totalResults: total,
				numberOfPages: Math.ceil(total/state.hcpsPerPage)
			}
		},
		setHcpsPerPage: (state, perPage) => {
			state.hcpsPerPage = perPage;
		},
		setIsPaginationEnabled: (state, status) => {
			state.isPaginationEnabled = status;
		},

		// Patients
		setPatients: (state, patients) => {
			state.patients = patients
		},
		setPatientsSortOption: (state, sortOption) => {
			state.patientsSortOption = sortOption
		},
		setPatientsSearchTerm: (state, searchTerm) => {
			state.patientsSearchTerm = searchTerm
		},

		// facetGroups
		setPortalFacetGroups: (state, facetGroups) => {
			const portalFacetGroups = JSON.parse(JSON.stringify(facetGroups));

			portalFacetGroups.forEach(group => {
				if (group.columnKey == "Added") {
					group.fromDate = group.fromDate || undefined;
					group.toDate = group.toDate || undefined;
				}
			})

			state.portalFacetGroups = portalFacetGroups;

		},
		setPortalSelectedFacetGroups: (state, facetGroups) => {
			let facets = [];

			facetGroups.forEach(group => {
				if (group.columnKey == "Added") {
					if ( group.fromDate || group.toDate ) {
						facets.push(
							{
								columnKey: group.columnKey,
								facet: `${group.fromDate || ''}${group?.fromDate && group?.toDate ? ' - ' : ''}${group.toDate || ''}`
							}
						)
					}
				} else {
					group.values.forEach(facet => {
						if ( facet.selected && !facets.includes(`${group.columnKey}:${facet.value}`)) {
							facets.push(
								{
									columnKey: group.columnKey,
									facet: `${facet.value}`
								}
							)
						}
					})
				}
			})

			state.selectedFacetGroups = facets;
		},
		setIsSearchResultEmpty: (state, status) => {
			state.isSearchResultEmpty = status;
		},
		setDefaultPortalFacetGroups: (state, facetGroups) => {
			const defaultFacetGroups = JSON.parse(JSON.stringify(facetGroups));
			defaultFacetGroups.forEach(group => {
				if (group.columnKey == "Added") {
					group.fromDate = undefined;
					group.toDate = undefined;
				} else {
					group.values.forEach(facet => {
						facet.selected = false;
					})
				}
			})
			state.defaultPortalFacetGroups = defaultFacetGroups;
		},
		setPatientsPagination: (state, pagination) => {
			state.patientsPagination = pagination
		},
		setCurrentPatientPage: (state, currentPage) => {
			state.currentPatientPage = currentPage
		},
		setIsSearchBusy: (state, status) => {
			state.isFetchBusy = status
		},

		setPatientOrders: (state, orders) => {
			state.patientOrders = orders
		},
		setPatientId: (state, id) => {
			state.patientId = id
		}
	},

	actions: {
		fetchHcps: ({ commit, state, dispatch }) => {
			commit('setSpinnerIsShown', true, { root: true });

			const mocksApiUrl = `${state.apiHcpsUrl}?mocks=25`

			// axios.get(state.apiHcpsUrl)
			axios.get(mocksApiUrl)
				.then(({ data }) => {
					if (data) {
						commit('setIsEmpty', data.isEmpty);
						commit('setHcps', data.table.rows);
						commit('setOriginHcps', data.table.rows);

						if (!state.isPaginationEnabled) {
							commit('setHcpsPerPage', data.table.rows.length)
						}

						commit('setHcpsPaginationCurrentPage', 1);
						commit('setHcpsPagination', data.table.rows.length);
						dispatch('sortByAdded')
					}
				})
				.catch(error => {
					console.warn(error);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true });
				});
		},

		sortByAdded: ({ commit, state, dispatch }, sortOption) => {
			const sortedHcps = [...state.hcps].sort((a, b) => {
				const isoDateA = getIsoDate(a);
				const isoDateB = getIsoDate(b);

				if (isoDateA === null && isoDateB === null) return 0;
				if (isoDateA === null) return 1;
				if (isoDateB === null) return -1;

				if ( sortOption == "asc" ) {
					return isoDateA.localeCompare(isoDateB);
				} else {
					return isoDateB.localeCompare(isoDateA);
				}
			});
			commit('setSortedHcps', sortedHcps);
		},

		searchHcps: ({ commit, state, dispatch }, searchTerm) => {
			commit('setHcps', state.originHcps);
			if ( searchTerm !== "" ) {
				const searchResults = state.hcps.filter((hcp) => {
					const name = getName(hcp)

					return name.toLowerCase().includes(searchTerm.toLowerCase())
				});
				commit('setHcps', searchResults);
			}

			commit('setHcpsPaginationCurrentPage', 1);
			commit('setHcpsPagination', state.hcps.length);
			dispatch('sortByAdded')
		},

		// Patients
		fetchPatients: ({ commit, state, dispatch }) => {
			commit('setSpinnerIsShown', true, { root: true });

			const mocksApiUrl = `${state.apiPatientsUrl}
								&sortOrder=${state.patientsSortOption || 'desc'}
								&q=${state.patientsSearchTerm || ''}
								&FacetString=${state.preparedSelectedFacetGroups.length ? state.preparedSelectedFacetGroups.join(";") : ""}
								&currentPage=${state.currentPatientPage}
								&mocks=35` // TODO remove &mocks=25

			axios.get(mocksApiUrl)
				.then(({ data }) => {
					if (data) {
						commit('setIsEmpty', data.isEmpty);
						commit('setIsSearchResultEmpty', data.isSearchResultEmpty);
						commit('setPatients', data.table.rows);
						commit('setPortalFacetGroups', data.facetGroups);
						commit('setDefaultPortalFacetGroups', data.facetGroups);

						if ( state.isPaginationEnabled ) {
							commit("setPatientsPagination", data.pagination)
						}
					}
				})
				.catch(error => {
					console.warn(error);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true });
					commit('setIsSearchBusy', false);
				});
		},

		useFacetFilterGroups: ({ commit, state, dispatch }, facetGroups) => {
			commit('setPortalSelectedFacetGroups', facetGroups)
			commit('setCurrentPatientPage', 1);

			state.preparedSelectedFacetGroups = [];

			facetGroups.forEach(group => {
				if (group.columnKey == "Added") {
					if ( group.fromDate ) {
						state.preparedSelectedFacetGroups.push(`${group.columnKey}.FromDate:${group.fromDate}`)
					}
					if (group.toDate) {
						state.preparedSelectedFacetGroups.push(`${group.columnKey}.ToDate:${group.toDate}`)
					}
				} else {
					group.values.forEach(facet => {
						if ( facet.selected && !state.preparedSelectedFacetGroups.includes(`${group.columnKey}:${facet.value}`)) {
							state.preparedSelectedFacetGroups.push(`${group.columnKey}:${facet.value}`)
						}
					})
				}
			})

			dispatch('fetchPatients')
		},

		restoreFacets:  ({ commit, state, dispatch }, facetGroups) => {
			commit('setPortalSelectedFacetGroups', facetGroups)
			commit('setPortalFacetGroups', facetGroups);
		},

		clearFacets: ({ commit, state, dispatch }) => {
			commit('setPortalSelectedFacetGroups', state.defaultPortalFacetGroups)
			state.preparedSelectedFacetGroups = [];
			commit('setCurrentPatientPage', 1);

			dispatch('fetchPatients')
		},

		removeFacet: ({ commit, state, dispatch }, payload) => {
			state.portalFacetGroups.forEach((group) => {
				if ( group.columnKey == payload.columnKey ) {
					if (group.columnKey == "Added") {
						group.fromDate = undefined;
						group.toDate = undefined;
					} else {
						group.values.forEach((facet) => {
							if ( facet.value == payload.facet ) {
								facet.selected = false;
							}
						})
					}
				}
			})

			dispatch("useFacetFilterGroups", state.portalFacetGroups)
		},

		fetchPatientOrders: ({ commit, state, dispatch }) => {
			commit('setSpinnerIsShown', true, { root: true });

			const mocksApiUrl = `${state.apiPatientOrdersUrl}
								&patientId=${state.patientId}
								&sortOrder=${state.patientsSortOption || 'desc'}
								&mocks=15` // TODO remove &mocks=

			axios.get(mocksApiUrl)
				.then(({ data }) => {

					if (data) {
						commit('setIsEmpty', data.isEmpty);
						commit('setPatientOrders', data.table.rows);
					}
				})
				.catch(error => {
					console.warn(error);
				})
				.finally(() => {
					commit('setSpinnerIsShown', false, { root: true });
					commit('setIsSearchBusy', false);
				});

		}
	}
}

const getIsoDate = (item) => {
	const addedColumn = item.values.find(val => val.columnKey === 'Added');
	return addedColumn ? addedColumn.valueInIso : null;
}

const getName = (item) => {
	const nameColumn = item.values.find(val => val.columnKey === 'Name');
	return nameColumn ? nameColumn.value : null;
}
